import React from "react";
import Footer from "./Footer/index";
import Header from "./Header/index";
import "./style.scss";

function Layout({ children}) {
  
  return (
    <div className="layoutStyle">
      <Header />
      <div className="layoutBody">{children}</div>
      <Footer />
    </div>
  );
}

export default Layout;
